﻿(function () {
    'use strict';

    var serviceId = 'repository.abstract';

    angular
        .module('app.services')
        .factory(serviceId, abstractRepository);

    function abstractRepository() {
        function Ctor() {
            this.isLoaded = false;
        };

        Ctor.extend = function(repoCtor) {
            repoCtor.prototype = new Ctor();
            repoCtor.prototype.constructor = repoCtor;
        };
        
        Ctor.prototype.getCount = getCount;

        return Ctor;

        function getCount(data) {
            return data.length;
        }
       
    }
})();